module.exports = __webpack_public_path__ + "media/images/underline-dark-blue-03f345662fc45962920668aa9452d151.svg";